// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Set = require("rescript/lib/js/belt_Set.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_MutableMap = require("rescript/lib/js/belt_MutableMap.js");
var Belt_MutableSet = require("rescript/lib/js/belt_MutableSet.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var MM_proof_verifier = require("./MM_proof_verifier.bs.js");

function proofTablePrint(ctx, tbl, title) {
  console.log("--- TBL " + title + " ---------------------------------------------------------------------------");
  tbl.map(function (__x) {
          var exprStr = MM_context.ctxIntsToStrExn(ctx, __x.expr);
          var match = __x.proof;
          var proofStr;
          proofStr = match.TAG === /* Hypothesis */0 ? "hyp: " + match.label : match.args.map(function (i) {
                    return i + 1 | 0;
                  }).join(", ") + " " + match.label;
          return "" + proofStr + " | " + exprStr + "";
        }).forEach(function (str, i) {
        console.log("" + String(i + 1 | 0) + ": " + str + "");
      });
  console.log("-----------------------------------------------------------------------------------");
}

function traverseRecordsInRpnOrder(tbl, targetIdx, onUse, onReuse) {
  var savedExprs = Belt_MutableSet.make(MM_context.ExprCmp);
  var reusedExprsSet = Belt_MutableSet.make(MM_context.ExprCmp);
  Expln_utils_data.traverseTree(undefined, Caml_array.get(tbl, targetIdx), (function (param, r) {
          var match = r.proof;
          if (match.TAG === /* Hypothesis */0 || Belt_MutableSet.has(savedExprs, r.expr)) {
            return ;
          } else {
            return match.args.map(function (a) {
                        return Caml_array.get(tbl, a);
                      });
          }
        }), undefined, (function (param, r) {
          var match = r.proof;
          if (match.TAG === /* Hypothesis */0) {
            Curry._1(onUse, r);
          }
          
        }), (function (param, r) {
          var match = r.proof;
          if (match.TAG !== /* Hypothesis */0) {
            if (Belt_MutableSet.has(savedExprs, r.expr)) {
              var firstReusage = !Belt_MutableSet.has(reusedExprsSet, r.expr);
              if (firstReusage) {
                Belt_MutableSet.add(reusedExprsSet, r.expr);
              }
              Curry._2(onReuse, r, firstReusage);
            } else {
              Belt_MutableSet.add(savedExprs, r.expr);
              Curry._1(onUse, r);
            }
          }
          
        }), undefined);
}

function collectReusedExprs(tbl, targetIdx) {
  var reusedExprs = [];
  traverseRecordsInRpnOrder(tbl, targetIdx, (function (param) {
          
        }), (function (r, firstReusage) {
          if (firstReusage) {
            reusedExprs.push(r.expr);
            return ;
          }
          
        }));
  return Belt_Set.fromArray(reusedExprs, MM_context.ExprCmp);
}

function createProof(ctx, tbl, targetIdx) {
  var tblLen = tbl.length;
  if (tblLen <= targetIdx) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "tblLen <= targetIdx"
          },
          Error: new Error()
        };
  }
  var mandHyps = MM_context.getMandHyps(ctx, Caml_array.get(tbl, targetIdx).expr);
  var mandHypLabelToInt = Belt_MapString.fromArray(mandHyps.map(function (param, i) {
            return [
                    param.label,
                    i + 1 | 0
                  ];
          }));
  var mandHypLen = Belt_MapString.size(mandHypLabelToInt);
  var labels = [];
  var labelToInt = function (label) {
    var i = labels.indexOf(label);
    return mandHypLen + (
            i !== -1 ? i + 1 | 0 : labels.push(label)
          ) | 0;
  };
  var reusedExprs = collectReusedExprs(tbl, targetIdx);
  var reusedExprToInt = Belt_MutableMap.make(MM_context.ExprCmp);
  var proofSteps = [];
  traverseRecordsInRpnOrder(tbl, targetIdx, (function (r) {
          var match = r.proof;
          var idx;
          if (match.TAG === /* Hypothesis */0) {
            var label = match.label;
            var i = Belt_MapString.get(mandHypLabelToInt, label);
            idx = i !== undefined ? i : labelToInt(label);
          } else {
            idx = labelToInt(match.label);
          }
          proofSteps.push(idx);
          if (Belt_Set.has(reusedExprs, r.expr)) {
            proofSteps.push(0);
            return Belt_MutableMap.set(reusedExprToInt, r.expr, Belt_MutableMap.size(reusedExprToInt) + 1 | 0);
          }
          
        }), (function (r, param) {
          proofSteps.push(-Belt_MutableMap.getExn(reusedExprToInt, r.expr) | 0);
        }));
  var labelsLastIdx = mandHypLen + labels.length | 0;
  return {
          TAG: /* Compressed */1,
          labels: labels,
          compressedProofBlock: proofSteps.map(function (i) {
                  if (i === 0) {
                    return "Z";
                  } else if (i < 0) {
                    return MM_proof_verifier.intToCompressedProofStr(labelsLastIdx - i | 0);
                  } else {
                    return MM_proof_verifier.intToCompressedProofStr(i);
                  }
                }).join("")
        };
}

function createProofTableFromProof(proofNode) {
  var processedExprs = Belt_MutableSet.make(MM_context.ExprCmp);
  var exprToIdx = Belt_MutableMap.make(MM_context.ExprCmp);
  var tbl = [];
  Expln_utils_data.traverseTree(undefined, proofNode, (function (param, n) {
          if (n.TAG === /* Hypothesis */0 || Belt_MutableSet.has(processedExprs, n.expr)) {
            return ;
          } else {
            return n.args;
          }
        }), undefined, (function (param, n) {
          if (n.TAG === /* Hypothesis */0) {
            var expr = n.expr;
            if (Belt_Option.isNone(Belt_MutableMap.get(exprToIdx, expr))) {
              var idx = tbl.push({
                    expr: expr,
                    proof: {
                      TAG: /* Hypothesis */0,
                      label: n.hypLabel
                    }
                  }) - 1 | 0;
              Belt_MutableMap.set(exprToIdx, expr, idx);
            }
            
          }
          
        }), (function (param, n) {
          if (n.TAG !== /* Hypothesis */0) {
            var expr = n.expr;
            if (Belt_Option.isNone(Belt_MutableMap.get(exprToIdx, expr))) {
              var idx = tbl.push({
                    expr: expr,
                    proof: {
                      TAG: /* Assertion */1,
                      args: n.args.map(function (n) {
                            var nExpr = MM_proof_verifier.getExprFromNode(n);
                            return Belt_Option.getWithDefault(Belt_MutableMap.get(exprToIdx, nExpr), -1);
                          }),
                      label: n.asrtLabel
                    }
                  }) - 1 | 0;
              Belt_MutableMap.set(exprToIdx, expr, idx);
            }
            
          }
          
        }), undefined);
  return tbl;
}

exports.createProof = createProof;
exports.createProofTableFromProof = createProofTableFromProof;
exports.proofTablePrint = proofTablePrint;
/* MM_context Not a pure module */
